export var siteConfig = {
  serverName: 'fdev',
  siteName: 'FinCover',
  siteIcon: 'ion-flash',
  footerText: 'FinCover ©2024 Created by <a href="https://www.brioworkx.com"> BrioWorkx, Inc </a>',
};

export const themeConfig = {
  topbar: 'themedefault',
  sidebar: 'themedefault',
  layout: 'themedefault',
  theme: 'themedefault',
};
export const language = 'english';

export const environment = 'production'; //production, development, local, pg, micro

var baseUrl = 'http://127.0.0.1:7000/';
var webUrl = 'http://127.0.0.1/';
var consumerUrl = 'http://127.0.0.1:3001/';
var userUrl = 'http://127.0.0.1:3001/';

export const app = "pos";       // pos,user,consumer
//var app = "consumer";

var prefix = app;
if (app == "pos") {
  prefix = "app";
}

if (environment == "production") {
  siteConfig.serverName = "fincover";
  baseUrl = "https://api.fincover.com/";
  webUrl = "https://" + prefix + ".fincover.com/";
  consumerUrl = "https://" + "consumer" + ".fincover.com/";
  userUrl = "https://" + "user" + ".fincover.com/";
}

if (environment == "development") {
  siteConfig.serverName = "fdev";
  // Dev LAN host is supplied via .env (REACT_APP_DEV_API) so no internal IP is
  // ever baked into a shipped bundle. Falls back to localhost when unset (e.g.
  // production/pg builds), keeping infra detail out of the client (VAPT).
  baseUrl = process.env.REACT_APP_DEV_API || "http://localhost:7000/";
  webUrl = "http://127.0.0.1/";
  consumerUrl = "http://127.0.0.1:3001/";
  userUrl = "https://" + "uatuser" + ".fincover.com/";
}

if (environment == "pg") {
  siteConfig.serverName = "fincover";
  baseUrl = 'https://pg.fincover.com/';
  if (app == "consumer") {
    webUrl = 'http://127.0.0.1:3001/';
  } else {
    webUrl = 'http://127.0.0.1:3000/';
  }
}

if (environment == "local") {
  siteConfig.serverName = "fdev";
  baseUrl = 'http://127.0.0.1:7000/';
  if (app == "consumer") {
    webUrl = 'http://127.0.0.1:3001/';
  } else {
    webUrl = 'http://127.0.0.1:3000/';
  }
}

// Micro backend — the secondary local Go server we spun up on port
// 7010 for the MF / family-folio experiments. The deployed
// `https://micro.fincover.com/` host was 400-ing the GraphQL endpoint;
// point the SPA at localhost:7010 instead so the same env switch
// continues to drive everything without touching the reverse-proxy
// config.
if (environment == "micro") {
  siteConfig.serverName = "fdev";
  baseUrl = 'http://127.0.0.1:7010/';
  if (app == "consumer") {
    webUrl = 'http://127.0.0.1:3001/';
  } else {
    webUrl = 'http://127.0.0.1:3000/';
  }
}

export const serverConfig = {
  uploadUrl: 'https://' + siteConfig.serverName + '-public.s3.ap-south-1.amazonaws.com/',
  baseUrl: baseUrl,
  imgBaseUrl: 'https://' + siteConfig.serverName + '-public.s3.ap-south-1.amazonaws.com/',
  insurerImages: 'https://' + siteConfig.serverName + '-public.s3.ap-south-1.amazonaws.com/' + "static/insurerimages/",
  amcImages: 'https://' + siteConfig.serverName + '-public.s3.ap-south-1.amazonaws.com/' + "static/financelogos/amclogos/",
  webUrl: webUrl,
  consumerUrl: consumerUrl,
  userUrl: userUrl,
  k:"LaYefdHLpQdsf"
};

export const apolloConfig = {
  graphqlUrl: serverConfig.baseUrl + "graphql"
};

export const chatConfig = {
  //    baseUrl: 'wss://meet.brioworkx.com/ws'
  baseUrl: baseUrl.replace("http", "ws") + "ws/"
};

export const devConfig = {
  environment: "production",   // development, production
}

export const firebaseConfig = {
  apiKey: "AIzaSyC61GzK6kCqwFm9QtrudDG6QjA2iKL98CE",
  authDomain: "fincover-messaging.firebaseapp.com",
  projectId: "fincover-messaging",
  storageBucket: "fincover-messaging.firebasestorage.app",
  messagingSenderId: "453914676515",
  appId: "1:453914676515:web:450aef272bdd7cc9f55096",
  vapidKey: "BPh0fZkybUAUROPjKcPvWynBqZpD4sBW6el6PgxSHGyuDYA8RwaTBHW2kYg7I8vXH6wNZTfi2J1CB1yZKgdIgTY",
  measurementId: "G-RNR1HQCY8V"
};
